import React from 'react';
import { Link } from 'react-router-dom';
import CountUp from 'react-countup';
import { Autoplay, Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/autoplay'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

import bgImg1 from "../../assets/images/backgrounds/slider-1-1.jpg";
import bgImg3 from "../../assets/images/backgrounds/slider-1-2.jpg";
import bgImg4 from "../../assets/images/backgrounds/slider-1-3.jpg";
import bgImg2 from "../../assets/images/shapes/main-slider-shape-2.png";
// import MainSliderImg1 from "../../assets/images/resources/main-slider-img-1-1.png";
import ContainerShear from "../../assets/images/resources/container-shear-fixed.png"
import DoubleShaftShreader from "../../assets/images/resources/double-shaft-shreader.png";
import VerticalScrap from "../../assets/images/resources/verical-scrap-shear.png";

import MainSliderImg3 from "../../assets/images/resources/main-slider-img-1-3.png";
import SliderContentShape1 from "../../assets/images/shapes/main-slider-content-shape-1.png";

const swiperOptions = {
  modules: [Autoplay, Pagination, Navigation],
  slidesPerView: 1,
  loop: true,
  effect: 'fade',
  pagination: {
    el: '#main-slider-pagination',
    type: 'bullets',
    clickable: true
  },
  navigation: {
    nextEl: '#main-slider__swiper-button-next',
    prevEl: '#main-slider__swiper-button-prev'
  },
  autoplay: {
    delay: 80000
  }
}

export default function Banner() {
  return (
    <section className="main-slider">
      <Swiper {...swiperOptions} className="swiper-container thm-swiper__slider">
        <SwiperSlide className="swiper-slide">
          <div
            className="main-slider__bg"
            style={{ backgroundImage: `url(${bgImg3})` }}
          />
          <div className="main-slider__shape-1" />
          <div
            className="main-slider__shape-2"
            style={{ backgroundImage: `url(${bgImg2})` }}
          />
          {/* <div className='' */}

          <div className='main-slider__content-wrapper'>
            {/* <div className="container"> */}
            <div className="main-slider__content">
              {/* <div className="main-slider__content-shape-1">
                <img src={DoubleShaftShreader} alt="ramana-double-shaft-shreader" />
              </div> */}
              <h2 className="main-slider__title">
                {/* Crafting <span>roofs</span> <br /> that withstand <br /> the test time */}
                Crush the <span>Toughest Scrap</span><br />
                Built for Heavy-Duty<br />
                Performance!
                <br />
                <br />
              </h2>
              <ul className="list-unstyled main-slider__counter">
                <li>
                  <div className="main-slider__counter-single">
                    <div className="main-slider__count count-box">
                      <h3 className="count-text">
                        <CountUp end={250} duration={1.5} />
                      </h3>
                      {/* <span>k</span> */}
                      <span>+</span>
                    </div>
                    <p className="main-slider__count-text">Machines Sold</p>
                  </div>
                </li>
                <li>
                  <div className="main-slider__counter-single">
                    <div className="main-slider__count count-box">
                      <h3 className="count-text">
                        <CountUp end={200} duration={1.5} />
                      </h3>
                      {/* <span>k</span> */}
                      <span>+</span>
                    </div>
                    <p className="main-slider__count-text">Our Team Member</p>
                  </div>
                </li>
              </ul>
              <div className="main-slider__btn-and-call-box">
                <div className="main-slider__btn-box">
                  <Link to="/contact" className="thm-btn-two main-slider__btn">
                    Get Quote   <span className="icon-dubble-arrow-right" />
                  </Link>
                  <a className="main-slider__call-number thm-btn-two main-slider__btn" href="tel:9815902561">CALL US AT +91-9815902561</a>
                </div>

              </div>
            </div>
            <div className="main-slider__img banner-margin">
              <img src={DoubleShaftShreader} alt="ramana-double-shaft-shreader" />
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <div
            className="main-slider__bg"
            style={{ backgroundImage: `url(${bgImg1})` }}
          />
          <div className="main-slider__shape-1" />
          <div
            className="main-slider__shape-2"
            style={{ backgroundImage: `url(${bgImg2})` }}
          />

          <div className='main-slider__content-wrapper'>
            {/* <div className="container"> */}
            <div className="main-slider__content">
              {/* <div className="main-slider__content-shape-1">
                <img src={DoubleShaftShreader} alt="ramana-double-shaft-shreader" />
              </div> */}
              <h2 className="main-slider__title">
                {/* Crafting <span>roofs</span> <br /> that withstand <br /> the test time */}
                Shear Metal with <span>Power</span>, <br />
                Faster, Stronger,
                Smarter!
                <br />
                <br />
                <br />

              </h2>
              <ul className="list-unstyled main-slider__counter">
                <li>
                  <div className="main-slider__counter-single">
                    <div className="main-slider__count count-box">
                      <h3 className="count-text">
                        <CountUp end={250} duration={1.5} />
                      </h3>
                      {/* <span>k</span> */}
                      <span>+</span>
                    </div>
                    <p className="main-slider__count-text">Machines Sold</p>
                  </div>
                </li>
                <li>
                  <div className="main-slider__counter-single">
                    <div className="main-slider__count count-box">
                      <h3 className="count-text">
                        <CountUp end={200} duration={1.5} />
                      </h3>
                      {/* <span>k</span> */}
                      <span>+</span>
                    </div>
                    <p className="main-slider__count-text">Our Team Member</p>
                  </div>
                </li>
              </ul>
              <div className="main-slider__btn-and-call-box">
                <div className="main-slider__btn-box">
                  <Link to="/contact" className="thm-btn-two main-slider__btn">
                    Get Quote <span className="icon-dubble-arrow-right" />
                  </Link>
                  <a className="main-slider__call-number thm-btn-two main-slider__btn" href="tel:9815902561">CALL US AT +91-9815902561</a>
                </div>

              </div>
            </div>
            <div className="main-slider__img items container-margin"
            >
              <img src={ContainerShear} alt="ramana-container-shear" />
            </div>
          </div>
        </SwiperSlide>

        <SwiperSlide className="swiper-slide">
          <div
            className="main-slider__bg"
            style={{ backgroundImage: `url(${bgImg4})` }}
          />
          <div className="main-slider__shape-1" />
          <div
            className="main-slider__shape-2"
            style={{ backgroundImage: `url(${bgImg2})` }}
          />
          <div className='main-slider__content-wrapper'>
            {/* <div className="container"> */}
            <div className="main-slider__content">
              <div className="main-slider__content-shape-1">
                <img src={SliderContentShape1} alt="" />
              </div>
              <h2 className="main-slider__title">
                Reduce, Recycle, <span>Reuse</span> <br />
                Heavy-Duty Shredding<br />
                Made Easy!
                <br />
                <br />
              </h2>
              <ul className="list-unstyled main-slider__counter">
                <li>
                  <div className="main-slider__counter-single">
                    <div className="main-slider__count count-box">
                      <h3 className="count-text">
                        <CountUp end={250} duration={1.5} />
                      </h3>
                      {/* <span>k</span> */}
                      <span>+</span>
                    </div>
                    <p className="main-slider__count-text">Machines Sold</p>
                  </div>
                </li>
                <li>
                  <div className="main-slider__counter-single">
                    <div className="main-slider__count count-box">
                      <h3 className="count-text">
                        <CountUp end={200} duration={1.5} />
                      </h3>
                      {/* <span>k</span> */}
                      <span>+</span>
                    </div>
                    <p className="main-slider__count-text">Our Team Member</p>
                  </div>
                </li>
              </ul>
              <div className="main-slider__btn-and-call-box">
                <div className="main-slider__btn-box">
                  <Link to="/contact" className="thm-btn-two main-slider__btn">
                    Get Quote<span className="icon-dubble-arrow-right" />
                  </Link>
                  <a className="main-slider__call-number thm-btn-two main-slider__btn" href="tel:9815902561">CALL US AT +91-9815902561</a>
                </div>
              </div>

            </div>
            {/* </div> */}
            <div className="main-slider__img">
              <img src={VerticalScrap} alt="" />
            </div>
          </div>
        </SwiperSlide>

        {/* Other Swiper Slides */}

      </Swiper>
      <div id="main-slider-pagination" className="swiper-pagination" />
    </section>
  );
}
